module.exports = __webpack_public_path__ + "assets/delivery-0f63ac.svg";